export default "__VITE_ASSET__DtrULkwA__"